<template>
    <path :style="{ fill: color }" d="M63.6,60.5c-0.4-1.2-2.7-1.7-2.7-1.7l0,0c-2.2-0.3-4.3-1.4-7-1.4l0,0v0c-2.7,0-4.8,1.1-7,1.4l0,0
	c0,0-2.4,0.5-2.7,1.7c-0.4,1.2-1.2,2.6-1,3.6c0.2,1,0.7,2.2,1,2.9c0.3,0.8,0.5,2.9,0.5,2.9s0.2,0.8,0.6,1.8c0.5,0.9,1,1.4,1.4,1.9
	c0.3,0.4,0.9,1.5,2.4,2.1c1.7,0.6,3.3,0.9,5,1v0l0,0c1.6-0.1,3.3-0.4,5-1c1.4-0.6,2-1.7,2.4-2.1c0.4-0.5,0.9-1,1.4-1.9
	c0.5-0.9,0.6-1.8,0.6-1.8s0.2-2.1,0.5-2.9c0.3-0.8,0.8-1.9,1-2.9C64.8,63.1,64,61.7,63.6,60.5z M53.8,65L53.8,65
	c-3.3,0-5.8-1.8-5.5-2.8c0.3-1,3.2-1.3,5.4-1.3c0,0,0,0,0.1,0v0l0,0c0,0,0,0,0.1,0c2.3,0,5.1,0.3,5.4,1.3C59.6,63.2,57.1,65,53.8,65
	L53.8,65z"/>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth3',
        mixins: [Mouth],
    }
</script>
